import Logo from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[#FAFAFA] border-t border-zinc-200"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-4 text-sm text-zinc-600 leading-relaxed max-w-xs">
              Practical AI and automation fixes for small businesses. We diagnose the
              bottleneck, then build the fix.
            </p>
          </div>

          <FooterCol
            title="Explore"
            links={[
              { href: "#assessment", label: "Assessment" },
              { href: "#how", label: "How it works" },
              { href: "#who", label: "Who it's for" },
              { href: "#scorecard", label: "Sample Scorecard" },
              { href: "#faq", label: "FAQ" },
            ]}
          />
          <FooterCol
            title="Engage"
            links={[
              { href: "#book", label: "Book Assessment" },
              { href: "mailto:hello@fynixsystems.com", label: "hello@fynixsystems.com" },
            ]}
          />
          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-500">
              Principles
            </div>
            <ul className="mt-4 space-y-2 text-sm text-zinc-700">
              <li>Systems over tools.</li>
              <li>Diagnosis before implementation.</li>
              <li>Measurable outcomes, not vanity metrics.</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-zinc-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-500">
            © {year} Fynix Systems · Bottleneck · Fixed
          </div>
          <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-500">
            Built for owners. Not enterprises.
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-500">
        {title}
      </div>
      <ul className="mt-4 space-y-2">
        {links.map((l) => (
          <li key={l.href}>
            <a
              href={l.href}
              className="text-sm text-zinc-700 hover:text-orange-600 transition-colors"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
